/* eslint-disable @typescript-eslint/no-explicit-any */
import { PropsWithChildren } from 'react';

import Svg from '../Svg';

import StyledTitle, {
  MenuTitle, IconTitle, OverlayTitle, CardTitle, StaticTitle,
} from './styles';

interface TitleWithIconProps {
  heading?: string;
  as: string;
  tag?: string;
  src?: string;
  alt?: string;
  p?: string;
  m?: string;
}

export const TitleWithIcon = ({
  children,
  heading,
  as,
  tag,
  src,
  alt,
  p,
  m,
}: PropsWithChildren<TitleWithIconProps>) => (
  <IconTitle as={as} p={p} m={m}>
    <Svg src={src} alt={alt} />
    {(children || heading) && <StyledTitle as={tag}>{children || heading}</StyledTitle>}
  </IconTitle>
);

export const Overlay = (props: any) => <TitleWithIcon as={OverlayTitle} {...props} />;

export const Card = (props: any) => <TitleWithIcon as={CardTitle} tag="h3" {...props} />;

export const Menu = (props: any) => <TitleWithIcon as={MenuTitle} {...props} />;

export const Default = (props: any) => <TitleWithIcon as={StaticTitle} {...props} />;
